<template>
<div>

<!-- Modal -->

  <div class="modal modal-mask" id="stockHistory" style="display: block">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">

    <div class="modal-content">
      <div class="modal-header">
        <h4 style="color:blue" class="modal-title" id="staticBackdropLabel"><strong>BRAND E FORNITORE</strong> </h4>
        
      </div>
      <div class="modal-body">
        <spinner v-if="spinner" v-bind:spinner='spinner'></spinner>
        
        <div v-else class="table-wrapper-scroll-y my-custom-scrollbar">  
        <table class="table table-bordered table-hover table-sm">
        <thead>
            <tr>
            <th scope="col">BRAND</th>    
            <th scope="col">FORNITORE</th>

            
            </tr>
        </thead>
        <tbody>
            <tr title="Doppio click seleziona fornitore" @dblclick="setData(item)" v-for="(item,index) in items" :key="index">
                <td class="text-nowrap">{{item.brand}}</td>
                <td class="text-nowrap">{{item.supplier}}</td>

                
                
                
            </tr>
        </tbody>
        </table>
        </div>



      </div>

      <div class="modal-footer">
        <button type="button"  @click="$emit('close')" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>


import spinner            from '@/components/common/Spinner.vue';

import api from '@/api'
import { mapGetters }    from 'vuex';
  export default {

  props : ['props'],
  components: {
     spinner
   
  },   
    data () {
      return {
        
          items : [],
          spinner : false     
      
      }
    },
    computed :{
    ...mapGetters(['company']),
   
  },

    created () 
      {
       // console.log(this.props)
        this.getData()
      },
    methods: 
    {
      setData(item)
      {
        this.$emit('update',item.supplierId,item.supplier)
        
      },
      async getData()
      {
        this.spinner = true
        const data = {'companyId' : this.company.Id}  
        const sp   = {'sp' : 'spBrandBySupplier'} 
        const json = Object.assign(data, sp)  
        
        

        await api.post(json).then(res => {
          if(res.status==200)
            {
             this.items = res.data.recordsets[0]
             

                 
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });

      },
          
    }
  }
</script>
<style scoped>

tr{
  cursor: pointer;
}

  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #E8A317;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
  .modal-xl {
   
   
   max-width: 50% !important;
   
}

</style>
